import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEN from '../public/locales/en.json'
import sharedTranslationsEn from '@client-hub/shared/assets/locales/en.json'

i18n.use(initReactI18next).init({
  resources: { en: { container: translationEN, shared: sharedTranslationsEn } },
  lng: 'en',
  fallbackLng: 'en',

  debug: process.env.NODE_ENV !== 'production',

  ns: ['container', 'shared'],
  defaultNS: 'container',

  interpolation: {
    escapeValue: false, // react already safes from xss
  },
})

export default i18n
